'use client';

import { Button } from '@common/components';
import { SvgDelete } from '@common/icon';
import { useState } from 'react';

import { CustomLink } from '@/components/atom/CustomLink';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { useAuthStore } from '@/stores/AuthStore';

interface TopBannerProps {
  appFileUrl?: string;
  appLinkUrl?: string;
  fileUrl?: string;
  linkUrl?: string;
  title?: string;
  targetNewYn?: boolean;
}

export const TopBanner = ({
  appFileUrl,
  appLinkUrl,
  fileUrl,
  linkUrl,
  title,
  targetNewYn,
}: TopBannerProps) => {
  const [isClose, setIsClose] = useState(false);
  const { isWelloApp } = useCheckWelloApp();
  const isLogin = useAuthStore((state) => state.isLogin);

  const applyFileUrl = isWelloApp ? appFileUrl : fileUrl;
  const applyLinkUrl = isWelloApp ? appLinkUrl : linkUrl;

  const isNoRender =
    !!isLogin ||
    isLogin === undefined ||
    isClose ||
    !(applyFileUrl && applyLinkUrl);

  if (isNoRender) return null;

  return (
    <CustomLink
      className="relative flex w-full items-center pt-[18.93%]"
      href={applyLinkUrl}
      target={targetNewYn ? '_blank' : '_self'}
    >
      <img
        alt={title}
        className="absolute left-0 top-0 size-full"
        src={applyFileUrl}
      />
      <Button
        className="absolute right-22 top-1/2 size-fit -translate-y-1/2 p-0"
        theme="sub-text"
        onClick={(e) => {
          e.preventDefault();
          setIsClose(true);
        }}
      >
        <SvgDelete className="size-20 text-Gray-900" />
      </Button>
    </CustomLink>
  );
};
